import { Component, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { CommonService, signinsService, LeadService, AdminService } from '../../../_services/';
import { emailListCreateContact } from '../../../_helper/global';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


// import * as firebase from 'firebase/app'; // Typescript
// // import firebase from 'firebase/app'; // JS
// import 'firebase/functions';

import { AngularFireFunctions } from '@angular/fire/functions';

@Component({
  selector: 'app-claim-signin',
  templateUrl: './claim-signin.component.html',
  styleUrls: ['./claim-signin.component.scss'],
  providers : [AngularFireFunctions]
})
export class ClaimSigninComponent implements OnInit {
  signinId:string;
  errMsg:string;
  signin:any;
  designerList:any[];
  contactId:string;
  contactSourceId:any;
  contactSourceList:any;
  claimSigninForm:FormGroup;
  private subscription: Subscription;
  submitted = false;
  constructor(
    private _route: ActivatedRoute,
    private fns : AngularFireFunctions,
    private _common: CommonService,
    private _signin: signinsService,
    private _lead: LeadService,
    private _admin: AdminService,
    private formBuilder : FormBuilder,
  ) { }

  ngOnInit() {
    this.claimSigninForm = this.formBuilder.group({
      owner_contact_id: ["", [Validators.required]],
      // hear_from: [null, []],
      contact_source_id: ["", [Validators.required]],
    })
    this._route.paramMap.subscribe(params => {
      this.signinId = params.get("id"); 
      this.getSignInData(this.signinId);
    })
    
    if(emailListCreateContact.includes(localStorage.getItem('rs-email'))){
      this.getDesignerList('all');
    }
    else {
      this.getDesignerList(localStorage.getItem('uid'));
    }
    this.getcontactSourceList();
  }

  // Get Signin Data
  getSignInData(signinId){
    this._common.showLoader(true);
    this._signin.getSignInData(signinId).subscribe(res=>{
      this._common.showLoader(false);
      this.signin = res.data();
      this.claimSigninForm.patchValue({ 
        contact_source_id : this.signin.source_id,
      })

    },err=>{
      this.errMsg = err && err.message ? err.message : 'Something went wrong!';
    })
  }

  // get designer list...
  getDesignerList(listType){
    this._common.showLoader(true);
    this._lead.getDesignerList(listType).subscribe(result=>{
      this._common.showLoader(false);
      this.designerList = result.map(item=> item.payload.doc.data());
    },error=>{
      this._common.showLoader(false);
      this.errMsg = error && error.message ? error.message : 'Something went wrong!';
    })
  }

      // get contact source list
  getcontactSourceList(){
    this._common.showLoader(true);
    this.subscription = this._admin.getContactSourceList().subscribe(result=>{
      this._common.showLoader(false);
      this.contactSourceList = result;
    },error=>{
      this._common.showLoader(false);
      // this._alert.error('Something went wrong');
    })
  }

  get fval() {
    return this.claimSigninForm.controls;
  }

  claimSignin(){
    this.errMsg = "";
    let form = this.claimSigninForm.value;

    if(!form.owner_contact_id){
      this.errMsg = "Please select designer to proceed!";
      return;
    }
    if(!form.contact_source_id){
      this.errMsg = "Please select source to proceed!";
      return;
    }
    this.submitted = true;
    // if (this.claimSigninForm.invalid) {
    //   return;
    // } 
    this._common.showLoader(true);
    if(window.location.host.includes('localhost')){
      this.fns.functions.useFunctionsEmulator('http://localhost:5000');
    }
    const obj = {signin_id: this.signinId,owner_contact_id: form.owner_contact_id, contact_source_id :form.contact_source_id };
    
    const claimSign = this.fns.httpsCallable('claim_signin');
    claimSign(obj).subscribe((result) => {
      this._common.showLoader(false);
      if(result.outcome==="success"){
        this._common.navigate ('contact/'+result.contact_id);
      }
      else {
        this.errMsg = result.message;
      }
    },err=>{
      this.errMsg = err && err.message ? err.message : 'Something went wrong!';
    });
  }

  ngOnDestroy(){
    if(this.subscription) this.subscription.unsubscribe();
  }
  
}

